import { RootState } from "@/store";
import { useSelector } from "react-redux";

export const useFiltersState = () => {
  return useSelector((state: RootState) => state.filtersSliceHistoryEngine);
};
